'use client'
import { useProductStore } from '@/hooks/use-cart-product/store'
import { setStoreSelector } from '@/hooks/use-cart-product/selectors'
import { useEffect } from 'react'

export default function ProductProvider({ products, upsellings }) {
  const setStore = useProductStore(setStoreSelector)

  useEffect(() => {
    setStore(products, upsellings)
  }, [products, setStore, upsellings])

  return <></>
}
